/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Avatar,
  Button,
  Dropdown,
  Image,
  TableColumnsType,
  Tag,
  Tooltip,
} from "antd";
import Header from "../../atoms/Header";
import TableUi from "../../atoms/Table";
import DashboardTemplate from "../../templates/Dashboard";
import Filters from "./Components/Filters";
import { useEffect, useRef, useState } from "react";
import { PotentialType } from "./ducks/types";
import { PopUp } from "../../atoms/PopUp";
import EmptyCard from "../../atoms/EmptyCard";
import { CrossIcon, DeleteIcon, NeedHelp } from "../../atoms/CustomIcons";
import ConfirmDelete from "../../atoms/ConfirmDelete";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import {
  getPotentialDealListing,
  removePotentialDealData,
} from "./ducks/actions";
import {
  changePotentialDealStatus,
  deletePotentialDeal,
} from "./ducks/services";
import SuccessMessage from "../../atoms/Toasts/SuccessMessage";
import ErrorMessage from "../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { getCompanyFieldsById } from "../CompanySettings/TagsCategories/ducks/actions";
import { useNavigate } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import {
  BILLING_MODAL,
  getInitials,
  getProbabilityColor,
  getValueBeforeUnderscore,
  NET_TERMS,
  PRICING_MODAL,
  PROPOSAL_STATUS,
  SALE_TYPE,
} from "../../config/utils";
import dayjs from "dayjs";

export default function PotentialDeals() {
  const location = window.location.pathname;
  const pathSegments = location.split("/");

  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const navigate = useNavigate();
  const [tableRecord, setTableRecord] = useState<PotentialType | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [archivePopUp, setArchivePopUp] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [archived, isArchived] = useState(false);
  const dispatch = useAppDispatch();
  const dealsListData = useAppSelector(
    (state) => state?.potentialDeal?.dealsListData
  );

  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
        module: "CLIENTS",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId]);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/edit-deal/${tableRecord?.id}/${companyId}`);
          }}
        >
          Edit deal details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/copy-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Make a copy
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/save-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Save as template
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Reset to template
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/lost-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Mark as lost
        </Button>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/archive-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            tableRecord?.status !== "archived"
              ? setArchivePopUp(true)
              : archiveFunction();
          }}
        >
          {tableRecord?.status !== "archived" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "7",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const columns: TableColumnsType<PotentialType> = [
    {
      title: "Deal name",
      dataIndex: "name",
      width: 270,
      render: (text) => (text ? text : "-"),
      fixed: "left",
    },
    {
      title: "Property name",
      dataIndex: "property",
      width: 192,
      ellipsis: true,
      render: (text) => (text ? text?.name : "-"),
    },
    {
      title: "Renewable",
      dataIndex: "renewable",
      width: 140,
      render: (text) => (text ? "Yes" : "No"),
    },
    {
      title: "Service line",
      dataIndex: "dealServiceLines",
      width: 273,
      render: (text) => {
        if (text && text.length > 0) {
          const seenIds = new Set();
          return (
            <div style={{ display: "flex", gap: "4px" }}>
              {text
                .filter((item: { service_line_id: string }) => {
                  if (seenIds.has(item?.service_line_id)) return false;
                  seenIds.add(item?.service_line_id);
                  return true;
                })
                .map(
                  (
                    item: { name: string; id: string; color: string },
                    i: number
                  ) => {
                    if (i < 2) {
                      return (
                        <Tag
                          key={item.id}
                          className={`defaultTag ${
                            item?.color
                              ? getValueBeforeUnderscore(item?.color)
                              : "default_tag"
                          }`}
                          style={{ textTransform: "capitalize" }}
                        >
                          {item?.name}
                        </Tag>
                      );
                    }
                    return false;
                  }
                )}
            </div>
          );
        }
        return "-";
      },
    },
    {
      title: "Deal status",
      dataIndex: "status",
      width: 175,
      render: (text) =>
        text && PROPOSAL_STATUS[text as keyof typeof PROPOSAL_STATUS] ? (
          <Tag
            className={`${
              text === "in_progress"
                ? "in_progress_tag"
                : text === "approval_pending"
                ? "approval_pending_tag"
                : text === "ready"
                ? "ready_tag"
                : text === "sent"
                ? "sent_tag"
                : text === "accepted"
                ? "accepted_tag"
                : text === "revision"
                ? "revision_tag"
                : text === "declined"
                ? "declined_tag"
                : text === "expired"
                ? "expired_tag"
                : text === "archived"
                ? "archived_tag"
                : "default_tag"
            } defaultTag`}
          >
            {PROPOSAL_STATUS[text as keyof typeof PROPOSAL_STATUS]}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: <Tooltip title="Total amount, $">Total amount, $</Tooltip>,
      dataIndex: "proposals",
      width: 140,
      align: "right",
      render: (text) =>
        text && text?.length > 0
          ? (() => {
              const totalSum = text?.reduce(
                (acc: any, curr: any) => acc + (curr?.total_amount || 0),
                0
              );
              return (
                <span>${Number(totalSum?.toFixed(2)).toLocaleString()}</span>
              );
            })()
          : "-",
    },
    {
      title: <Tooltip title="GM, %">GM, %</Tooltip>,
      dataIndex: "gross_margin",
      align: "right",
      width: 140,
      render: (_text, record) =>
        record?.proposals && record?.proposals.length > 0
          ? (() => {
              let calculatedTotalPrice = 0;
              let calculatedTotalAmount = 0;
              (record?.proposals ?? []).forEach((item: any) => {
                calculatedTotalPrice += item?.total_price || 0;
                calculatedTotalAmount += item?.total_cost || 0;
              });

              let grossMargin = 0;
              if (calculatedTotalPrice && calculatedTotalAmount) {
                grossMargin = parseFloat(
                  Number(
                    ((calculatedTotalPrice - calculatedTotalAmount) /
                      calculatedTotalPrice) *
                      100
                  ).toFixed(1)
                );
              }
              return <span>{grossMargin}%</span>;
            })()
          : "-",
    },
    {
      title: <Tooltip title="Gross profit, $">Gross profit, $</Tooltip>,
      dataIndex: "gross_profit",
      width: 140,
      align: "right",
      render: (_text, record) =>
        record?.proposals && record?.proposals.length > 0
          ? (() => {
              let calculatedTotalPrice = 0;
              let calculatedTotalAmount = 0;
              (record?.proposals ?? []).forEach((item: any) => {
                calculatedTotalPrice += item?.total_price || 0;
                calculatedTotalAmount += item?.total_cost || 0;
              });

              const grossProfit = calculatedTotalPrice - calculatedTotalAmount;
              return (
                <span>${Number(grossProfit?.toFixed(2)).toLocaleString()}</span>
              );
            })()
          : "-",
    },

    {
      title: "Probability",
      dataIndex: "probability",
      width: 120,
      render: (text) =>
        text ? (
          <Tag
            style={{ backgroundColor: getProbabilityColor(text), border: 0 }}
          >
            {text}%
          </Tag>
        ) : (
          "-"
        ),
    },

    {
      title: <Tooltip title="Date created">Date created</Tooltip>,
      dataIndex: "created_date",
      width: 130,
      render: (text) => (text ? dayjs(text).format("ll") : "-"),
    },
    {
      title: "Contract start date",
      dataIndex: "start_date",
      width: 170,
      render: (text) => (text ? dayjs(text).format("ll") : "-"),
    },
    {
      title: <Tooltip title="Contract end date">Contract end date</Tooltip>,
      dataIndex: "end_date",
      width: 170,
      render: (text) => (text ? dayjs(text).format("ll") : "-"),
    },
    {
      title: "Responsible manager",
      dataIndex: "manager_name",
      width: 192,
      render: (text, record) =>
        text ? (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {record?.manager_image_url ? (
              <Avatar src={record?.manager_image_url} size={24} />
            ) : (
              <Avatar>{getInitials(text, "")}</Avatar>
            )}
            {text}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Client",
      dataIndex: "property",
      width: 190,
      render: (text) => (text ? text?.client?.name : "-"),
    },
    {
      title: "Pricing model",
      dataIndex: "pricing_model",
      width: 140,
      render: (text) =>
        text && PRICING_MODAL[text as keyof typeof PRICING_MODAL]
          ? PRICING_MODAL[text as keyof typeof PRICING_MODAL]
          : "-",
    },
    {
      title: "Billing model",
      dataIndex: "billing",
      width: 140,
      render: (text) =>
        text && BILLING_MODAL[text as keyof typeof BILLING_MODAL]
          ? BILLING_MODAL[text as keyof typeof BILLING_MODAL]
          : "-",
    },
    {
      title: "Net terms",
      dataIndex: "net_terms",
      width: 140,
      render: (text) =>
        text && NET_TERMS[text as keyof typeof NET_TERMS]
          ? NET_TERMS[text as keyof typeof NET_TERMS]
          : "-",
    },
    {
      title: "Type of sale",
      dataIndex: "sale_type",
      width: 140,
      render: (text) =>
        text && SALE_TYPE[text as keyof typeof SALE_TYPE]
          ? SALE_TYPE[text as keyof typeof SALE_TYPE]
          : "-",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const fetchUserListing = () => {
    const payload = {
      company_id: companyId,
      offset: 0,
      limit: 10,
    };
    dispatch(getPotentialDealListing(payload));
  };

  const deleteFunction = () => {
    setLoading(true);
    deletePotentialDeal(
      selectedRowKeys?.length > 0 ? selectedRowKeys : [tableRecord?.id || ""]
    )
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        setSelectedRowKeys([]);
        fetchUserListing();
        SuccessMessage("Deal deleted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const deleteClientPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          selectedRowKeys?.length > 1 ? (
            <>
              Are you sure you want to delete selected deals?
              <br />
              They won't be available anymore.
            </>
          ) : (
            <>
              Are you sure you want to delete this deal?
              <br />
              This action cannot be undone.
            </>
          )
        }
        btnText={
          selectedRowKeys?.length > 1
            ? `Delete ${selectedRowKeys?.length} potential deals`
            : "Delete potential deal"
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const archiveFunction = () => {
    setLoading(true);
    const payload = {
      status: tableRecord?.status !== "archived" ? "archived" : "active",
    };
    changePotentialDealStatus(tableRecord?.id as string, payload)
      .then(() => {
        setLoading(false);
        setArchivePopUp(false);
        fetchUserListing();
        SuccessMessage(
          `Deal ${
            tableRecord?.status !== "archived" ? "archived" : "activated"
          }.`
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const confirmArchivedPopUp = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading={tableRecord?.status !== "archived" ? "Archive" : "Activate"}
        paragraph={
          <>
            Are you sure you want to{" "}
            {tableRecord?.status !== "archived" ? "archive" : "activate"}{" "}
            <b>{tableRecord?.name}</b>? <br />
            {tableRecord?.status !== "archived" && (
              <>You can restore it any moment later.</>
            )}
          </>
        }
        btnText={`${
          tableRecord?.status !== "archived" ? "Archive" : "Activate"
        } `}
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  useEffect(() => {
    dispatch(removePotentialDealData());
  }, [dispatch]);

  useEffect(() => {
    if (companyId) {
      const payload = {
        status: filters?.status ?? undefined,
        offset: 0,
        limit: 10,
        company_id: companyId,
        type: filters?.type ?? undefined,
        search_text: filters?.search_text ?? undefined,
      };
      dispatch(getPotentialDealListing(payload));
    }
  }, [dispatch, filters, pagination, limit, companyId]);

  const onClickRow = (record: PotentialType) => {
    return {
      onClick: () => {
        navigate(`/deals-detail/${record?.id}/${companyId}`);
      },
    };
  };

  return (
    <DashboardTemplate loading={loading || dealsListData?.loader}>
      <Header
        title="Potential deals"
        description="View and manage estimates and proposals."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />

      <TableUi<PotentialType>
        columns={columns}
        data={{
          count: dealsListData?.count,
          data: dealsListData?.data || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        createButtonText="New deal"
        createButtonLink={`/create-deal/${companyId}`}
        onClickRow={onClickRow}
      />
      {!dealsListData?.loader && dealsListData?.data?.length === 0 && (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={220}
            title={
              archived
                ? "There are no archived potential deals"
                : filters?.search_text
                ? "No results match the filter or search criteria"
                : `There are no ${filters?.status ?? "active"} potential deals`
            }
            description={
              archived
                ? "We believe in our absolute success and hope to never have an archived potential deals here."
                : filters?.search_text
                ? "Try adjusting the filters and search."
                : ""
            }
            image={
              archived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar">
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${
              selectedRowKeys.length === 1
                ? "potential deal"
                : "potential deals"
            }`}{" "}
            selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<DeleteIcon />}
              onClick={() => {
                setIsDeleteModalOpen(true);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...deleteClientPopUp} />
      <PopUp {...confirmArchivedPopUp} />
    </DashboardTemplate>
  );
}
